module.exports = ".headerInline {\n    display: inline;\n}"